import { createSelector } from "reselect";

//Selectors
import { mergedDescriptionSchemasSelector } from "src/selectors/section_selectors/global/merged_description_schemas_selector";

//Utils
import { extractTypeKeysFromSchema } from "src/utils/downloadable_schemas/extract_type_keys_from_schema";

export const woundTypeKeysForAllSchemasSelector = createSelector(
  mergedDescriptionSchemasSelector,
  mergedSchemaQuestions => {
    return extractTypeKeysFromSchema({
      attributes: {
        schemaJson: {
          questions: mergedSchemaQuestions
        }
      }
    });
  }
);
